import React, { createContext, useContext } from 'react';
import { createPortal } from 'react-dom';
import IconActions from './IconActions';

export const FormActionsContext = createContext(null);

// Fields own their logic; the form card owns the position of their actions.
export function FormFooterAction({ children }) {
  const host = useContext(FormActionsContext);
  const actions = <IconActions>{children}</IconActions>;
  return host ? createPortal(actions, host) : actions;
}
